import React from 'react';
import DOMPurify from 'dompurify';
import dayjs from 'dayjs';
import {
  Modal,
  Image,
  Text,
  Avatar,
  Group,
  Tooltip,
  Paper,
} from '@mantine/core';

function ViewStoryModal({ setIsViewModal, BlogId, isViewModal, blogdata }) {
  const story = blogdata;

  return (
    <div>
      <Modal
        opened={isViewModal}
        onClose={() => setIsViewModal(false)}
        title={
          <div className='flex items-center justify-start  rounded-md w-full bg-[#FFF8F6]'>
            <Paper className='bg-[#FFF8F6] m-3'>
              <Group>
                <Avatar
                  radius='xl'
                  size={50}
                  color='#FB7C51'
                  src={story?.profile_picture}
                >
                  <p>
                    {story?.user__first_name &&
                      story?.user__first_name.substring(0, 1)}
                  </p>
                </Avatar>
                <div>
                  <Text className='text-lg font-normal'>
                    {story?.user__first_name}
                  </Text>
                  <div className='flex items-center justify-around space-x-2 mt-1'>
                    <Tooltip
                      label='Created on'
                      classNames={{
                        body: 'bg-white text-gray2 shadow-tooltip pr-3 z-0',
                      }}
                      radius='md'
                    >
                      <Text className='text-gray3 font-normal' size='xs'>
                        {dayjs(story?.created_date).format('DD MMM YYYY')}
                      </Text>
                    </Tooltip>
                    <Text className='text-gray3 font-normal' size='xs'>
                      .
                    </Text>
                    <Text className='text-gray3' size='xs'>
                      {story?.minutes} mins read
                    </Text>
                  </div>
                </div>
              </Group>
            </Paper>
          </div>
        }
        size={'60%'}
        centered
        overlayColor={'#F8F7F799'}
        overlayBlur={20}
        overlayOpacity={0.5}
        transitionDuration={100}
        overflow='inside'
        className='px-10'
        classNames={{
          title: 'text-lg font-semibold  text-xl w-full ',
          body: 'scroller  h-full',
        }}
      >
        <div className='pr-8'>
          <div className=''>
            <h1 className=' text-2xl text-left font-black '>{story.title}</h1>
            <h2 className=' text-lg text-left text-gray3 '>{story?.topic}</h2>
          </div>
          {story?.thumbnail ? (
            <Image
              radius='md'
              className='my-4'
              src={story?.thumbnail}
              alt={story?.title}
              caption='Illustration by the author'
            />
          ) : (
            <Image src={null} alt={story?.title} withPlaceholder />
          )}

          <div
            className='mt-4 mx-2 text-justify'
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(story?.content),
            }}
          ></div>
        </div>
      </Modal>
    </div>
  );
}

export default ViewStoryModal;
